import { createModal } from '/@/core/elements/modal'
import { type SpoakSignType } from '/@/common/SpoakSign/types'
import { type DesignerGroup, type DesignerTier } from '/@/data/designer/types'

export interface Designer {
  id: string
  firstName: string
  lastName: string
  tier: DesignerTier
  nickname: string
  imageUrl?: string
  hometown?: string
  bio?: string
  instagramHandle?: string
  pinterestHandle?: string
  tiktokHandle?: string
  website?: string
  sign?: SpoakSignType
  groups: DesignerGroup[]
}

export interface DesignerModalData {
  designerId: string | null
}

const { api, component } = createModal<DesignerModalData>(
  'DesignerModal',
  () => import('./DesignerModal.vue'),
  {
    designerId: null,
  },
)

export const useDesignerModal = api
export default component
